import sitemap from './sitemap.json';

export { sitemap };
